import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo, useState } from 'react'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import Input from '../../../../../FormComponents/Input'
import CurrencyField from '../../../../../FormComponents/CurrencyField'
import { separateThousands, currencyFormat, currencyUnit } from '../../../../../../utils/Helper'

export default observer(function ShowAll({ values, handleChange, handleBlur }) {
  const { selectedScenario, campaign } = useContext(CampaignContext)
  const actions = selectedScenario?.actions.filter(action => action.visible_in_budget)

  const actualInfAmount = useMemo(() => [...new Set(actions.map(action => action.influencer_id))].length, actions)
  const grossReach = useMemo(() => actions.reduce((result, action) => result + action.reach, 0))
  const netReach = useMemo(() => actions.reduce((result, action) => result + action.action_insight?.reach, 0))
  const impression = useMemo(() => actions.reduce((result, action) => result + (action.action_insight?.impressions || action?.action_insight?.story_first_sequence_impressions || 0), 0))
  const totalAdvertiserPrice = useMemo(() => actions.reduce((result, action) => result + action.totalAdvertiserPrice, 0))
  const socialAdsSpend = useMemo(() => Number(values?.paid_spend_overview) || 0, [values?.paid_spend_overview])

  return (
    <div className="mb-8">
      <table className="w-full border-1 border-gray-100 rounded-lg">
        <thead>
          <tr>
            <th className="w-1/3 border-1 border-gray-100 bg-gray-100"></th>
            <th className="w-1/3 border-1 border-gray-100 bg-gray-100 text-left font-normal py-4">Goal</th>
            <th className="w-1/3 border-1 border-gray-100 bg-gray-100 text-left font-normal py-4">Actual</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Amount of influencers</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <Input
                topMargin=''
                name='influencer_amount'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.influencer_amount}
              />
            </td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <Input
                topMargin=''
                disabled
                value={actualInfAmount}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Reasoning - Amount of influencers</td>
            <td className="p-4" colSpan="2">
              <Input
                topMargin=''
                placeholder="State the reasons"
                name='influencer_amount_reason'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.influencer_amount_reason}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Amount of uploads</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <Input
                topMargin=''
                name='upload_amount'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.upload_amount}
              />
            </td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <Input
                topMargin='mt-0'
                disabled
                value={selectedScenario.actions.filter(action => action.visible_in_budget).length}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Reasoning - Amount of uploads</td>
            <td className="p-4" colSpan="2">
              <Input
                topMargin=''
                placeholder="State the reasons"
                name='upload_amount_reason'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.upload_amount_reason}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Gross reach</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <CurrencyField
                topMargin=''
                placeholder='Gross reach'
                name='gross_reach'
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={0}
                valueIsNumericString={true}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.gross_reach}
              />
            </td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <Input
                topMargin=''
                disabled
                value={separateThousands(grossReach)}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Reasoning - Gross reach</td>
            <td className="p-4" colSpan="2">
              <Input
                topMargin=''
                placeholder="State the reasons"
                name='gross_reach_reason'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.gross_reach_reason}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Net reach</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <CurrencyField
                topMargin=''
                placeholder='Net reach'
                name='net_reach'
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={0}
                valueIsNumericString={true}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.net_reach}
              />
            </td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <Input
                topMargin=''
                disabled
                value={separateThousands(netReach)}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Reasoning - Net reach</td>
            <td className="p-4" colSpan="2">
              <Input
                topMargin=''
                placeholder="State the reasons"
                name='net_reach_reason'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.net_reach_reason}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Impressions</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <CurrencyField
                topMargin=''
                placeholder='Impressions'
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={0}
                valueIsNumericString={true}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.impression}
              />
            </td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <Input
                topMargin=''
                disabled
                value={separateThousands(impression)}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Reasoning - Impressions</td>
            <td className="p-4" colSpan="2">
              <Input
                topMargin=''
                placeholder="State the reasons"
                name='impression_reason'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.impression_reason}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Influencer budget</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <CurrencyField
                topMargin=''
                addon={currencyUnit(campaign.currency)}
                name='influencer_budget'
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
                fixedDecimalScale={true}
                valueIsNumericString={true}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.influencer_budget}
              />
            </td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <Input
                topMargin=''
                disabled
                value={currencyFormat(totalAdvertiserPrice.toFixed(2), campaign.currency)}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Reasoning - Influencer budget</td>
            <td className="p-4" colSpan="2">
              <Input
                topMargin=''
                placeholder="State the reasons"
                name='influencer_budget_reason'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.influencer_budget_reason}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Social ads budget</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <CurrencyField
                topMargin=''
                addon={currencyUnit(campaign.currency)}
                placeholder='Social ads budget'
                name='social_ads_budget'
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
                fixedDecimalScale={true}
                valueIsNumericString={true}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.social_ads_budget}
              />
            </td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <Input
                topMargin=''
                disabled
                value={currencyFormat(socialAdsSpend.toFixed(2), campaign.currency)}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Reasoning - Social ads budget</td>
            <td className="p-4" colSpan="2">
              <Input
                topMargin=''
                placeholder="State the reasons"
                name='social_ads_budget_reason'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.social_ads_budget_reason}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
})